import UiElement from '../../../shared/ui-element/ui-element';

import './search.scss';

class Search extends UiElement {
  constructor(props) {
    super();
    if (props) {
      this.onOpen = props.onOpen;
      this.onClose = props.onClose;
    }
  }

  ui = {
    body: 'body',
    searchBlock: '.js-search-block',
    searchPlaceholder: '.js-search-placeholder',
    searchInput: '.js-search-input',
    closeBtn: '.js-close-btn',
  };

  events = {
    'mousedown @ui.body': 'handleSearchClose',
    'mousedown @ui.searchBlock': (e) => e.stopPropagation(), // in order not to trigger body mousedown
    'mousedown @ui.searchPlaceholder': 'handleSearchOpen',
    'mousedown @ui.closeBtn': 'handleSearchClose',
    'click @ui.searchBlock': 'focusOnSearchInput',
    'click @ui.closeBtn': (e) => e.stopPropagation(), // in order not to trigger searchBlock click
    'focus @ui.searchInput': 'showCloseButton',
  };

  searchCollapsedClass = 'search_collapsed';

  closeBtnHiddenClass = 'search__close-btn_hidden';

  handleSearchOpen(e) {
    e.stopPropagation();

    this.ui.searchBlock.classList.remove(this.searchCollapsedClass);
    if (this.onOpen) this.onOpen();
  }

  focusOnSearchInput() {
    this.ui.searchInput.focus();
  }

  handleSearchClose(e) {
    e.stopPropagation();

    this.ui.searchInput.value = '';
    this.ui.closeBtn.classList.add(this.closeBtnHiddenClass);

    if (this.ui.searchBlock.dataset.canCollapse === '1') {
      this.ui.searchBlock.classList.add(this.searchCollapsedClass);
    }

    if (this.onClose) this.onClose();
  }

  showCloseButton() {
    this.ui.closeBtn.classList.remove(this.closeBtnHiddenClass);
  }
}

export default Search;
